export default __webpack_public_path__ + "static/media/humidity.54481d2c.svg";